import ModalNotification from 'model/notifications';
import { Reducer, useReducer } from 'react';

type ModalNotificationsState = {
  notifications: ModalNotification[];
};
type ModalNotificationAction = {
  type: string;
  payload?: ModalNotification;
};

const initialState: ModalNotificationsState = {
  notifications: [],
};

const reducer: Reducer<ModalNotificationsState, ModalNotificationAction> = (
  state: ModalNotificationsState,
  action: ModalNotificationAction,
) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION':
      return {
        notifications: [
          ...state.notifications,
          action.payload,
        ] as ModalNotification[],
      };
    case 'REMOVE_NOTIFICATION':
      return { notifications: state.notifications.slice(1) };
    default:
      return state;
  }
};

const useModalNotifications = () => {
  const [state, dispatch] = useReducer<
    Reducer<ModalNotificationsState, ModalNotificationAction>
  >(reducer, initialState);

  const addModalNotification = (notification: ModalNotification) => {
    dispatch({
      type: 'ADD_NOTIFICATION',
      payload: notification,
    });
  };

  const closeModalNotification = () => {
    dispatch({
      type: 'REMOVE_NOTIFICATION',
    });
  };

  return {
    modalNotifications: state.notifications,
    addModalNotification,
    closeModalNotification,
  };
};

export default useModalNotifications;
